import { DEFAULT_CURRENCY_CODE, getStaticCurrencyByCode } from './currencies'

/** Mirrors api/lib/visitorCountry.ts — default invoice currency per visitor country. */
const CURRENCY_CODE_BY_COUNTRY: Record<string, string> = {
  US: 'USD',
  GB: 'GBP',
  CA: 'CAD',
  ES: 'EUR',
  AU: 'AUD',
  ZA: 'ZAR',
}

export function getCurrencyCodeForCountry(countryCode: string | null | undefined): string {
  if (!countryCode) {
    return DEFAULT_CURRENCY_CODE
  }
  const upper = countryCode.trim().toUpperCase()
  const normalized = upper === 'UK' ? 'GB' : upper
  return CURRENCY_CODE_BY_COUNTRY[normalized] ?? DEFAULT_CURRENCY_CODE
}

/** Sync fallback until GET /api/invoices/default-currency returns (timezone logic lives in the API). */
export function resolveBusinessCurrencyCode(options: {
  savedCode?: string | null
  invoiceCode?: string | null
  defaultCode?: string | null
}): string {
  const saved = options.savedCode?.trim()
  if (saved) {
    return saved
  }
  const invoice = options.invoiceCode?.trim()
  if (invoice) {
    return invoice
  }
  const fromApi = options.defaultCode?.trim()
  if (fromApi) {
    return fromApi
  }
  return DEFAULT_CURRENCY_CODE
}

export function getVisitorCurrency(countryCode: string | null | undefined) {
  const code = getCurrencyCodeForCountry(countryCode)
  return getStaticCurrencyByCode(code) ?? getStaticCurrencyByCode(DEFAULT_CURRENCY_CODE)!
}
